// metrics imports
import { CreateMetric } from 'views/QualityQuotient/CreateMetric/CreateMetric';
import { CreateAssessment } from 'views/QualityQuotient/CreateAssessment/CreateAssessment';
import { UserMetrics } from 'views/QualityQuotient/UserMetrics/UserMetrics';
import { UserAssessments } from 'views/QualityQuotient/UserAssessments/UserAssessments';
import { EnrolMetrics } from 'views/QualityQuotient/EnrolMetrics/EnrolMetrics';

// common quiz imports
import { QuizCommon } from 'views/CommonQuiz/QuizCommon/QuizCommon';
import { QuizLevel } from 'views/CommonQuiz/QuizLevel/QuizLevel';
import { QuizEnroll } from 'views/CommonQuiz/QuizEnroll/QuizEnroll';
import { UserQuiz } from 'views/CommonQuiz/UserQuiz/UserQuiz';
import { BadgeSharing } from 'views/CommonQuiz/BadgeSharing/BadgeSharing';

// quality quotient imports
import { UserQuizzes } from 'views/QualityQuotient/UserQuizzes/UserQuizzes';
import { QualityReport } from 'views/QualityQuotient/QualityReport/QualityReport';

// diy quiz imports
import { DiyQuiz } from 'views/QuizAndAssessment/DIYQuiz/DIYQuiz';
import { DiyAssessment } from 'views/QuizAndAssessment/DIYQuiz/DIYAssessment';
import { AssessmentRouter } from 'views/QuizAndAssessment/DIYQuiz/AssessmentRouter';
import { UserAssessmentRouter } from 'views/QuizAndAssessment/DIYQuiz/UserAssessmentRouter';
import { StudentResultsTable } from 'views/QuizAndAssessment/DIYQuiz/ReportTable/StudentsResultsTable';

const Routes = [
    // metric routes
    {
        path: '/metrics/:action',
        view: CreateMetric,
        layout: 'app',
        permission: 'metric.action.view',
        title: 'QualityQuotient.CreateMetric.title.create',
    },
    {
        path: '/metrics/:id/:action',
        view: CreateMetric,
        layout: 'app',
        permission: 'metric.action.view',
        title: 'QualityQuotient.CreateMetric.title.edit',
    },
    {
        path: '/metrics/:metricId/assessment/:assessId',
        view: CreateAssessment,
        layout: 'app',
        permission: 'metric.assessment.view',
        title: 'QualityQuotient.CreateAssessment.title',
    },
    {
        path: '/user/metrics',
        view: UserMetrics,
        layout: 'app',
        permission: 'user.metrics.view',
        title: 'QualityQuotient.UserMetrics.title',
    },
    {
        path: '/user/metrics/:metricId/assessments',
        view: UserAssessments,
        layout: 'app',
        permission: 'user.metrics.assessments.view',
        title: 'QualityQuotient.UserAssessments.title',
    },
    {
        path: '/user/metrics/enroll',
        view: EnrolMetrics,
        layout: 'app',
        permission: 'user.metrics.enroll.view',
        title: 'QualityQuotient.EnrolMetrics.title',
    },
    {
        path: '/user/metrics/:metricId/report',
        view: QualityReport,
        layout: 'appPlain',
        permission: 'user.metrics.report.view',
        title: 'QualityQuotient.QualityReport.title.metric',
        mobile: true,
    },
    {
        path: '/user/assessment/:assessId/:context',
        view: QuizCommon,
        layout: 'appPlain',
        permission: 'user.assessment.context.view',
        title: 'CommonQuiz.QuizCommon.title.assessment',
    },
    // qq routes
    {
        path: '/qq/:qqID/:context',
        view: QuizCommon,
        layout: 'appPlain',
        permission: 'user.quiz.view',
        title: 'CommonQuiz.QuizCommon.title.qq'
    },
    {
        path: '/qq',
        view: UserQuizzes,
        layout: 'app',
        permission: 'user.quiz.view',
        title: 'QualityQuotient.UserQuizzes.title',
        mobile: true
    },
    {
        path: '/qq/report',
        view: QualityReport,
        layout: 'appPlain',
        permission: 'user.quiz.report.view',
        title: 'QualityQuotient.QualityReport.title.qq',
        mobile: true,
    },
    // common quiz
    {
        path: '/quiz',
        view: UserQuiz,
        layout: 'app',
        permission: 'user.quiz.view',
        title: 'CommonQuiz.UserQuiz.title',
    },
    {
        path: '/quizzes/:c_quiz_id/userbadge',
        view: BadgeSharing,
        layout: 'appPlain',
        permission: 'user.quiz.badge.view',
        title: 'CommonQuiz.BadgeSharing.title',
    },
    {
        path: '/quizzes/:c_quiz_id/level',
        view: QuizLevel,
        layout: 'app',
        permission: 'user.quiz.level.view',
        title: 'CommonQuiz.QuizLevel.title'
    },
    {
        path: '/quiz/all',
        view: QuizEnroll,
        layout: 'app',
        permission: 'user.quiz.enroll.view',
        title: 'CommonQuiz.QuizEnroll.title'
    },
    {
        path: '/quizzes/:c_quiz_id/level/:level_id/quiz/:context',
        view: QuizCommon,
        layout: 'appPlain',
        permission: 'user.quiz.context.view',
        title: 'CommonQuiz.QuizCommon.title.quiz'
    },
    //Diy quiz
    {
        path: '/diy-quiz',
        view: DiyQuiz,
        layout: 'app',
        permission: 'diyquiz.view',
        title: 'DIY Quiz'
    },
    {
        path: '/diy-quiz/:diyQuizId/assessments',
        view: DiyAssessment,
        layout: 'app',
        permission: 'user.diyquiz.view',
        title: 'DIY Assesments'
    },
    {
        path: '/diy-quiz/:diyQuizId/assessments/create',
        view: AssessmentRouter,
        layout: 'appPlain',
        permission: 'diyquiz.assessments.view',
        title: 'DIY Assesments'
    },
    {
        path: '/diy-quiz/:diyQuizId/assessments/:assessmentId/edit',
        view: AssessmentRouter,
        layout: 'appPlain',
        permission: 'diyquiz.assessments.edit.view',
        title: 'DIY Assesments'
    },
    {
        path: '/assessments/:assessmentId',
        view: UserAssessmentRouter,
        layout: 'public',
        title: 'Assessments'
    },
    {
        path: '/diy-quiz/:diyQuizId/assessments/:assessmentId/reports',
        view: StudentResultsTable,
        layout: 'appPlain',
        permission: 'diyquiz.assessments.reports.view',
        title: 'Assessment Reports'
    },
]

export default Routes;
